import React from 'react';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';
import { HospitalBank } from 'types/hospital';

interface HospitalBanksListProps {
  banks: HospitalBank[];
  handleDeleteBank(bank: HospitalBank, index: number): void;
  handleEditBank(bank: HospitalBank, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'bank', label: 'Banco' },
  { id: 'holder', label: 'Titular' },
  { id: 'agency', label: 'Agência' },
  { id: 'account', label: 'Conta' },
  { id: 'pix', label: 'Chave Pix' },
];

const HospitalBanksList: React.FC<HospitalBanksListProps> = ({ banks, handleDeleteBank, handleEditBank }) => (
  <RecordList
    columns={columns}
    rows={banks.map((bank, index) => ({
      key: bank.id || index,
      values: {
        bank: bank.bank_name,
        holder: bank.account_holder || '-',
        agency: bank.bank_agency || '-',
        account: bank.bank_account || '-',
        pix: bank.pix_key ? `${bank.pix_key_type ? `${bank.pix_key_type} · ` : ''}${bank.pix_key}` : '-',
      },
    }))}
    onEdit={index => handleEditBank(banks[index], index)}
    onDelete={index => handleDeleteBank(banks[index], index)}
  />
);

export default HospitalBanksList;
